import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withLeaflet } from 'react-leaflet';
import PopupMenu from 'components/PopupMenu';
import withEdit from 'containers/EditService/withEdit';
import getSnap from 'utils/getSnap';
import {
  TRAVELMODE_CYCLING,
  TRAVELMODE_WALKING,
  TRAVELMODE_STRAIGHT,
} from 'utils/directions/constants';
import messages from './HoverMarker/messages';

class PathMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.walking = this.reroute(TRAVELMODE_WALKING).bind(this);
    this.cycling = this.reroute(TRAVELMODE_CYCLING).bind(this);
    this.straight = this.reroute(TRAVELMODE_STRAIGHT).bind(this);
  }

  componentDidMount() {
    const { leaflet } = this.props;
    this.snap = getSnap(leaflet.map);
  }

  handleClick(item) {
    return pos => this[item](pos);
  }

  addPoint(pos) {
    const { addPoint, travelMode } = this.props;
    addPoint({ ...pos, snap: this.snap }, travelMode);
  }

  insertPoint(pos) {
    const { insertPoint, travelMode, leg } = this.props;
    insertPoint(leg.id, { ...pos, snap: this.snap }, travelMode);
  }

  reroute(travelMode) {
    const { replacePath, leg } = this.props;
    return () => {
      replacePath(leg.id, travelMode);
    };
  }

  render() {
    const { onOpen, onClose, position } = this.props;
    return (
      <PopupMenu
        items={['addPoint', 'insertPoint', 'walking', 'cycling', 'straight']}
        messages={messages}
        onClick={this.handleClick}
        onOpen={onOpen}
        onClose={onClose}
        position={position}
      />
    );
  }
}

PathMenu.propTypes = {
  addPoint: PropTypes.func.isRequired,
  insertPoint: PropTypes.func.isRequired,
  replacePath: PropTypes.func.isRequired,
  travelMode: PropTypes.string.isRequired,
  position: PropTypes.object,
  leg: PropTypes.object.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  leaflet: PropTypes.object.isRequired,
};

export default compose(
  withLeaflet,
  withEdit,
)(PathMenu);
